 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		36: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		36: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","3":"vendors~GDPRPrompt~PlaylistPage~PlaylistWrapped~teamChat~teamFans~teamGames~teamGmTools~teamMain~tea~95c5a89d","7":"vendors~FrontPage~teamGmTools~teamScores~teamSquads","8":"GDPRPrompt","9":"vendors~GamePage~TeamPage~userHeader","11":"GamePage-Details~ssUiGameVenue","12":"vendors~UserWidgetsPage~ssUiPremiumWidgetSubscriptions","13":"vendors~teamNoMatch~userHandOfGodInspector","14":"vendors~userHandOfGodInspector~userHeader","15":"EmbedHeader","16":"FrontPage","17":"GamePage","18":"GamePage-Chat","19":"GamePage-Details","20":"GamePage-Fans","21":"GamePostPage","22":"HandOfGod","23":"HeaderFrontPage","24":"Internal-NotificationsPage","25":"Internal-SystemMetricsPage","26":"InternalPage","27":"NoMatchPage","28":"NotificationsPage","29":"PlaylistPage","30":"PlaylistWrapped","31":"TeamPage","32":"UpdateGameModal","33":"UserPage","34":"UserWidgetsPage","35":"WidgetCreatorsPage","37":"cachedLevelsOfPlay","38":"logosAndSponsors","39":"scheduleWidget","40":"ssTeamScheduleWidget","41":"ssUiGameVenue","42":"ssUiPremiumWidgetSubscriptions","43":"ssUiTeamOverrideManager","44":"ssUiTeamScheduleWidget","45":"ssUiTeamVenueManager","46":"ssUiTrendingList","47":"ssUiVenueTypeToFind","48":"teamChat","49":"teamFans","50":"teamGames","51":"teamGmTools","52":"teamMain","53":"teamMedia","54":"teamNoMatch","55":"teamScheduleCreator","56":"teamScheduleCreatorForm","57":"teamScores","58":"teamSquads","59":"userEdit","60":"userEditCommunicationSettings","61":"userFollowers","62":"userFollowing","63":"userHandOfGodInspector","64":"userHeader","65":"userMedia","66":"userPage","67":"userTeams","68":"vendors~GamePage","69":"vendors~GamePage-Fans","70":"vendors~Internal-SystemMetricsPage","71":"vendors~NotificationsPage","72":"vendors~UserWidgetsPage","73":"vendors~scheduleWidget","74":"vendors~userEditCommunicationSettings","75":"vendors~userHandOfGodInspector"}[chunkId]||chunkId) + "." + {"0":"6000ea83e5476f36cd07","1":"2864b11346511562206d","2":"e863c8bc8fc6543ae3d4","3":"d22fb0fb8ad38ede43e9","4":"847e262b167c710f22d6","5":"c4024bdf893d0fa81486","6":"5be1a2a973c50722a92e","7":"65a58e555086928af337","8":"370bf72f1f53313d4bdf","9":"ecb83a8502086a117ab7","10":"e6ee46f7eee2a0a9116f","11":"1c3cec92be1023942937","12":"1402c2a97977bcf3c709","13":"e9cff7765849e84cd995","14":"54e240e4166bf8c14206","15":"bac4dedb2e0c9b18c947","16":"74272ab97d6314d38477","17":"fb2fb51a907dec8676e9","18":"78de331feed43bd3a65b","19":"cf2463842c24e4ca5372","20":"abb7deeedc38dc5cfaf5","21":"87328fb031b25758f084","22":"25d6d84536f617653d94","23":"c296718e8d7aca4a988b","24":"8cf0fa2a58cad63bb99d","25":"aa350c8f5b446b07f774","26":"17d2fdb0a9280ce32904","27":"b99fa7c3ca1ab2eefaba","28":"68eb30321e95af13178a","29":"fed7c38086958dcc92e0","30":"6a45213a3d594b85f824","31":"75ba283806272f9b8090","32":"a0172f94700738ab3700","33":"888b41c42543a3ecb518","34":"bbb03f54c7a238abfd32","35":"e38d5aec0f741091c901","37":"896d737ff03689f62379","38":"8bedf660706f6dc57ba3","39":"80da922abe5e3fd7a861","40":"769e4c6c7558f83447ad","41":"762a321233d94aa0153c","42":"04b820ef2898d7c692fa","43":"f46ded0a3e31c65c4c95","44":"4473462e9de56ef5ef7a","45":"fa62ab42bf6ecb49abf7","46":"a851a7540d0acd351cfb","47":"1e47828683d61aa58d55","48":"81c2e2ff113ec3fb85d5","49":"2d211d3f5d2027b00e54","50":"41f17fb3e2f3f7e9e9f8","51":"7b05b8405c46dbe93383","52":"ff64e312a7e87a933bab","53":"7b72a7c5ce3bf27adf0a","54":"a16cdbaf88ccf0b54330","55":"dac1bb010e211370a8af","56":"bc600a9af01b55367379","57":"eb6e382eed331103b183","58":"4c204e73a5b45fff7a2a","59":"b80ec76b7925848d2b6f","60":"bcfb6409ddedf1c24787","61":"c4c4f4519b331ce2a68c","62":"8e352ee111ce8fbc46c4","63":"53af0fc0c086e33d16b8","64":"89baf46d76b67d9dbe46","65":"44df3806a7a601db3cfe","66":"b6b4763a4b63cd020455","67":"6ef1fc6b6594f8f82ac8","68":"5affc174ca6be1ee871b","69":"70a71869b7534381ba00","70":"50ec748c501dc237d3d4","71":"09052bd080a457d5feaa","72":"6f30ceca40ead40fbc9f","73":"754415c06936629d180f","74":"3d667255b68f3f7a2123","75":"dddef089774bca8f91f3","76":"d4de1eac4f81be46c80f","77":"2aa5655f65ae70f8114a","78":"0839d8518e3da6bf3a8d","79":"d49f296ed0322dc0d4e3","80":"2d41e7678817d674ed0d","81":"7d4744985246fcba8581","82":"34767e4f09e319633ac9","83":"e132d7e5c226e77b574f","84":"09ee6b96719e3e864752","85":"1cc609a12b85f87409b6","86":"63cd10b2f96295e42e2f","87":"850950aa266634a7ce45"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + chunkId + ".extractedFromBundle." + "090de85bd3fc1cdd5ec7" + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "realtime/app";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["ssuiWebpackJsonp"] = window["ssuiWebpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 874);
